export default function Dialog(theme) {
  return {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontFamily: 'Poppins, sans-serif',
          fontWeight: 600,
          fontSize: '0.95rem',
          lineHeight: 1.4,
          padding: '16px 24px 8px',
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          fontFamily: 'Poppins, sans-serif',
          fontSize: '0.82rem',
          padding: '8px 24px 16px',
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '8px 24px 16px',
        },
      },
    },
  };
}
